import { ReactComponent as ChevronIcon } from 'assets/icons/chevron.svg';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { contributorVaultsTitles } from 'config/constants';
import { classnames } from 'helpers/utils';
import { RouteName, goToPage } from 'routes';
import styles from './contributor-table-row.module.scss';

type ContributorVaultsRowsProps = {
  vaults: VaultType[];
};

const ContributorVaultsRows: React.FC<ContributorVaultsRowsProps> = ({
  vaults,
}) => (
  <div className={styles.vaultsRows}>
    <div className={styles.titles}>
      {Object.keys(contributorVaultsTitles).map((title) => (
        <div
          key={title}
          className={classnames(
            styles[title],
            'text__body__semi__bold__medium__gray800',
          )}
        >
          {contributorVaultsTitles[title]}
        </div>
      ))}
    </div>
    <div
      className={classnames(
        styles.body,
        'text__body__regular__medium__gray700',
      )}
    >
      {vaults.map((vault: VaultType) => (
        <div key={vault.id} className={styles.vaultRow}>
          <div className={styles.vaultName}>{vault.title}</div>

          <div className={classnames(styles.column, styles.owner)}>
            {vault.owner?.name}
          </div>

          <div className={classnames(styles.column, styles.companyName)}>
            {vault.owner?.companyName}
          </div>

          <div className={classnames(styles.column, styles.actions)}>
            <Button
              className={styles.detailsButton}
              buttonStyle={ButtonStyle.LinkColor}
              buttonSize={ButtonSize.Small}
              onClick={() => {
                goToPage(RouteName.VaultDetail, { id: vault.id });
              }}
            >
              <span className={styles.noWrap}>Vault details</span>
              <span className={styles.chevronIcon}>
                <ChevronIcon />
              </span>
            </Button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export { ContributorVaultsRows };
